import {Component, Input} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {NgIf, NgClass} from '@angular/common';

export type MessageType = 'error' | 'info' | 'warning' | 'success';

@Component({
  selector: 'app-embedded-message',
  standalone: true,
  imports: [
    MatIconModule,
    NgIf,
    NgClass
  ],
  template: `
    <div class="d-flex flex-column align-items-center gap-16">
      <div>
        <span class="material-symbols-outlined text-5xl" [ngClass]="getIconColor()">
            {{ getIcon() }}
        </span>
      </div>
      <div class="color-black-700 font-medium text-xl text-center">{{ title }}</div>
      <div class="d-flex flex-column align-items-center gap-8">
        <div [innerHTML]="textContent" class="color-black-500 font-normal text-base text-center"></div>
        <div *ngIf="actionText" class="color-black-400 font-normal text-sm text-center">
          {{ actionText }}
        </div>
      </div>
    </div>
  `,
})
export class EmbeddedMessageComponent {
  @Input() title = '';
  @Input() textContent = '';
  @Input() type: MessageType = 'info';
  @Input() actionText = '';

  getIcon(): string {
    switch (this.type) {
      case 'error':
        return 'error';
      case 'info':
        return 'info';
      case 'warning':
        return 'warning';
      case 'success':
        return 'check_circle';
      default:
        return 'info';
    }
  }

  getIconColor(): string {
    switch (this.type) {
      case 'error':
        return 'color-error-icon'; 
      case 'info':
        return 'color-information-icon'; 
      case 'warning':
        return 'color-warning-icon'; 
      case 'success':
        return 'color-success-icon'; 
      default:
        return 'color-blue-600';
    }
  }
} 